/*
* Copyright (C) Regione Lombardia
*/
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CoreI18nConfigs } from '@core/configs/i18n.config';
import {
    AnagraficaComuni,
    AnagraficaTipologiaOpera,
    DatalistAnagrafica,
    OperaStatoEnum
} from '@models';
import { OperaService } from '@shared/services/opera.service';
import { PermessiService } from '@shared/services/permessi.service';
import { UtilsService } from '@shared/services/utils.service';

@Component({
    selector: 'app-pages-gestione-opera-crea-opera',
    templateUrl: './crea-opera.component.html',
    styleUrls: ['./crea-opera.component.scss'],
})
export class PagesGestioneOperaCreaOperaComponent implements OnInit {

    public stepper = {
        currentStep: 1,
    };
    public tipoInserimento: string;
    public criteriaForm: FormGroup;
    public formStato: FormGroup;
    public datalist: DatalistAnagrafica;
    public comuniFiltered: AnagraficaComuni[] = [];
    public tipologiaOperaFiltered: AnagraficaTipologiaOpera[] = [];

    constructor(
        private operaService: OperaService,
        private utilsService: UtilsService,
        private router: Router,
        private route: ActivatedRoute,
        private fb: FormBuilder,
        public permessiService: PermessiService,
    
    ) {
        this.criteriaForm = this.operaService.generateFormOpera();
    }

    ngOnInit() {
        this.initFormStato();
        this.permessiService.initPermessiOpera();
        this.datalist = this.route.snapshot.data['additionalInformation'].datalist;
    }

    public stepperPrevious() {
        this.stepper.currentStep--;
    }

    public stepperNext() {
        switch(this.stepper.currentStep) {
            case 1:
                if (!this.criteriaForm.controls['tipoInserimento'].value) {
                    this.utilsService.showWarning('Per proseguire è obbligatorio selezionare la tipologia di inserimento.');
                    return;
                }
                this.operaService.setRequiredValidators(this.criteriaForm);
                this.stepper.currentStep++;
                break;
            case 2:
                if(this.criteriaForm.get('annoFineEsistenza')?.invalid) {
                    this.utilsService.showWarning('Inserire un anno valido compreso tra il 1900 e il 2099');
                    return;
                } else if (this.criteriaForm.invalid) {
                    this.utilsService.showWarning(CoreI18nConfigs.messages.fieldRequired);
                    this.criteriaForm.markAllAsTouched();
                    return;
                }
                this.stepper.currentStep++;
                break;
            case 3:
                this.operaService.create(this.criteriaForm.getRawValue()).subscribe(response => {
                    this.utilsService.showSuccess(CoreI18nConfigs.messages.genericSuccess);
                    this.router.navigate(['../dettaglio', response.idOpera], { relativeTo: this.route });
                });
                break;
        }
    }

    public setTipoInserimento(tipoInserimento: number) {
        this.criteriaForm.controls['tipoInserimento'].setValue(tipoInserimento);
    }

    setStatoOpera() {
        this.criteriaForm.get('idStato')?.setValue(this.formStato.get('stato')?.value);
    }

    initFormStato() {
        this.formStato = this.fb.group({
            stato: this.fb.control(OperaStatoEnum.BOZZA)
        });    
        this.criteriaForm.get('idStato')?.setValue(this.formStato.get('stato')?.value);
    }


}
